export const parseSeoBlockField = (field) => {
  switch (field.type) {
    case "JSON":
      return JSON.parse(field.content);
    case "TEXT":
    default:
      return field.content;
  }
}
